import React from 'react';
import {
  IconFileDescriptionFilled,
  IconVolume,
  IconMovie,
  IconListFilled,
  IconPhotoFilled,
  IconLibraryPhoto,
  IconHelpOctagonFilled,
  IconForms,
  IconSitemapFilled,
  IconCameraFilled,
  IconTableFilled,
  IconMicrophoneFilled,
  IconRobot,
  IconCube,
  IconBrush,
  IconHelpCircle,
} from '@tabler/icons-react';

// Maps the Material-icon ligature names stored in
// Config.GET_HOTSPOT_CONTENT_CONFIG(kind).icon to Tabler icons, so the hotspot
// content list (HotspotDetailView) and the Create Content dialog
// (CreateContentDialog) render the SAME icon for each content type.
//
// Filled variants are used where Tabler provides them; the rest fall back to
// the outline icon (no filled variant exists in @tabler/icons-react 3.44).
const LIGATURE_TO_ICON = {
  art_track: IconFileDescriptionFilled, // 圖文描述
  record_voice_over: IconVolume,        // 聲音導航 (no filled)
  local_movies: IconMovie,              // 短片 (no filled)
  list: IconListFilled,                 // 文字選擇題 / 文字多項選擇題
  photo: IconPhotoFilled,               // 圖片選擇題
  photo_library: IconLibraryPhoto,      // 圖片多項選擇題 (no filled)
  contact_support: IconHelpOctagonFilled, // 問題
  text_format: IconForms,               // 填充 (no filled)
  category: IconSitemapFilled,          // 概念圖填充題
  photo_camera: IconCameraFilled,       // 拍照題
  table_chart: IconTableFilled,         // 新增表格
  mic: IconMicrophoneFilled,            // 錄音／訪問
  face6: IconRobot,                     // NPC 虛擬角色 (no filled)
  view_in_ar: IconCube,                 // 3D模型 (no filled)
  draw: IconBrush,                      // 繪圖題 (no filled)
  help_outline: IconHelpCircle,         // fallback
};

export function ContentTypeIcon({ ligature, size = 24, color = '#868e96', stroke = 1.6, style }) {
  const Icon = LIGATURE_TO_ICON[ligature] || IconHelpCircle;
  return <Icon size={size} color={color} stroke={stroke} style={style} />;
}

export default ContentTypeIcon;
